import bankAccountLengthMessage from './bankAccountLengthMessage';

const errorMessages = (errors, validatorKey) => {
  const bankAccountLength = bankAccountLengthMessage(validatorKey);

  const messages = {
    bankBranchLength:           'Número da agência deve ter 4 digitos.',
    cpf:                        'Por favor, digite um CPF válido. O CPF precisa conter 11 digitos.',
    email:                      'Por favor, preencha com um endereço de e-mail válido.',
    employerLength:             'Max. 40 caracteres',
    internationalDate:          'Por favor, adicione uma data válida.',
    laterThanBirthDate:         'Por favor, adicione uma data de emissaão válida.',
    minimumAge:                 'Você precisar ter pelo menos 18 anos para ser um cliente Simplic.',
    minimumZipcodeLength:       'CEP precisa ter ao menos 5 digitos.',
    monthlyIncomeLength:        'Por favor, digite cinco ou menos dígitos',
    moreThanJustNumbers:        'Por favor, insira algo diferente de apenas números.',
    moreThanOneWord:            'Você deve digitar mais de uma palavra',
    passwordLength:             'Por favor tente novamente. A sua senha deve ter 7 ou mais caracteres',
    phoneNumberLength:          'Por favor, preencha um número de telefone valido (DDD) + 9 dígitos - (XX) XXXXX-XXXX',
    secondaryPhoneNumberLength: 'Por favor, preencha um número de telefone valido (DDD) + 9 ou 8 dígitos - (XX) XXXXX-XXXX',
    privacyPolicyAgreed:        'Esse campo é obrigatório.',
    positiveCreditDataAgreed:   'Esse campo é obrigatório.',
    required:                   'Esse campo é obrigatório.',
    requiredOne:                'Selecione pelo menos uma.',
    sameAsPassword:             'Essas senhas não conferem. Tentar novamente.',
    sameAsEmail:                'e-mail não corresponde',
    uniqueBankAccount:          'O seu conta bancária já está cadastrado na nossa base de clientes.',
    uniqueCPF:                  'O seu CPF já está cadastrado na nossa base de clientes. <a href="/login">Entrar</a>',
    uniqueEmail:                'O seu email já está cadastrado na nossa base de clientes. <a href="/login">Entrar</a>',
    bankAccountLength,
  };
  return errors.map((error) => messages[error]);
};
export default errorMessages;
